/* eslint-disable no-use-before-define */
import { createApi } from '@reduxjs/toolkit/query/react';
import rcBaseQuery from './baseQuery';

export const projectApi = createApi({
    reducerPath: 'projectApi',
    baseQuery: rcBaseQuery,
    tagTypes: ['Project', 'ProjectList'],
    endpoints: (builder) => ({
        // Lightweight project list with title counts
        getProjects: builder.query({
            query: () => ({
                url: 'api/v2/projects'
            }),
            providesTags: [{ type: 'ProjectList', id: 'ALL' }]
        }),
        // Single project detail
        getProject: builder.query({
            query: ({ id }) => ({
                url: 'project',
                params: { id }
            }),
            providesTags: (result, error, { id }) => [{ type: 'Project', id }]
        })
    })
});

export const { useGetProjectsQuery, useGetProjectQuery } = projectApi;
